import React from 'react';
import { MouTemplateType } from 'eve-account-client';
import { AuthFileLinkProps } from '../../AuthFileLink';

export type MouLinkType = MouTemplateType | string;

export interface EveTermsOfUseProps {
  isCorporateAccountSelected: boolean;
  linkToMou?: React.ReactElement<AuthFileLinkProps<MouLinkType>>;
}

const EveTermsOfUse = ({ isCorporateAccountSelected, linkToMou }: EveTermsOfUseProps): JSX.Element => {
  return (
    <div className="grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
      {!isCorporateAccountSelected && (
        <>
          <p>
            By submitting this enrollment, I affirm that I have read and agree with the terms and conditions of the{' '}
            {linkToMou}, and am authorized by my company to act on its behalf with respect to the E-Verify program. I
            understand that I must complete the electronic enrollment in order for the MOU to take effect.
          </p>
          <p>
            <strong>IMPORTANT:</strong> The MOU sets forth my company’s responsibilities under the E-Verify program.
            Failure to comply with the MOU may lead to legal liability for my company under federal and state law,
            including the payment of back pay, civil monetary penalties, and other damages under Title VII of the Civil
            Rights Act of 1964 and the anti-discrimination provision of the Immigration and Nationality Act. You should
            print the MOU, and share it with your Human Resources Manager, legal counsel, and other appropriate staff.
          </p>
        </>
      )}
      <p>
        I certify that the information provided for this enrollment is correct. I am aware that Federal law provides for
        imprisonment and/or fines for knowing false statements or other fraudulent conduct in connection with the
        registration. I am aware that providing any false information may be grounds for terminating participation in
        E-Verify.
      </p>
    </div>
  );
};

export default EveTermsOfUse;
